import { FC, useCallback, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { PagesPaths } from '@/enums';
import styles from './Footer.module.scss';

const getCurrentYear = () => {
  const currentDate = new Date();
  return currentDate.getFullYear();
};

type FooterProps = {
  isPrivate?: boolean;
};

const Footer: FC<FooterProps> = ({ isPrivate }) => {
  const { t, i18n } = useTranslation('footer');

  const changeLanguage = (lng: 'es' | 'en') => {
    i18n.changeLanguage(lng).finally(() => {
      localStorage.setItem('language', lng);
      window.location.reload();
    });
  };

  const loadLanguagePreference = useCallback(() => {
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
  }, [i18n]);

  useEffect(() => {
    loadLanguagePreference();
  }, [loadLanguagePreference]);

  return (
    <footer className={classNames(styles.footer, isPrivate && styles.darkText)}>
      <div>
        <p className={classNames(isPrivate && styles.darkText)}>
          Ciudadela 1278, bloque B
        </p>
        <p className={classNames(isPrivate && styles.darkText)}>
          Montevideo - Uruguay
        </p>
        <p className={classNames(isPrivate && styles.darkText)}>
          Tel (+598) 2915 0404
        </p>
        <p className={classNames(isPrivate && styles.darkText)}>
          Tel 0800 0404
        </p>
        <p>Fax (+598) 2915 8656</p>
        <nav>
          <Link to={PagesPaths.Contact}>{t('contact')}</Link>
          {/* <Link to="/">{t('termsOfUse')}</Link> */}
        </nav>
      </div>
      <div>
        <p>
          © {getCurrentYear()} Montecon. {t('allRightsReserved')}
        </p>
        <div>
          <button type="button" onClick={() => changeLanguage('es')}>
            Español
          </button>
          <button type="button" onClick={() => changeLanguage('en')}>
            English
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
